import Image from 'next/image';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { MIN_MOBILE_WIDTH } from '@common/Utility/common-utils';
import { IC_CALL_BLUE, IC_CLOSE_MODAL, IC_CONTACT, IC_CONTACT_EMAIL } from '../../Assets/images';
import Loader from '../Loader/Loader';
import { HelpPopUpStyled } from './HelpPopUpStyled';

const HelpPopUp = (props) => {
  const router = useRouter();
  const isTeleconsultRoute = router?.pathname?.indexOf('/doctor-consultation') > -1;
  const [doctorHelpLine, setDoctorHelpLine] = useState('');
  const appConfig = useSelector((state) => state?.astercore?.AppConfig?.data?.data);
  const loadingresponse = useSelector((state) => state?.teleconsultant?.myPrescriptionOrderDetails?.isFetching);

  useEffect(() => {
    setDoctorHelpLine(appConfig?.find((config) => config?.name === 'doctorHelpLineNo')?.value);
  }, [appConfig?.length]);

  const handleClick = () => {
    props?.setShowContactSideBar(true);
    props.close();
  };

  return (
    <HelpPopUpStyled>
      <Loader isLoading={loadingresponse} />

      <div id="open-modal" className="modal-window">
        <div>
          <a className="modal-close" data-testid="closeButton" onClick={() => props.close()}>
            <Image src={IC_CLOSE_MODAL.src} width={46} height={46} alt="" />
          </a>
          <div className="d-flex flex-wrap align-items-center">
            <div>
              <div className="modal_title">We&apos;re Here To Help</div>
              <div className="modal_subtitle">
                {' '}
                Reach out to our customer care team through the below support channels.
              </div>
            </div>
            <div className="contact_email d-flex flex-wrap  align-items-center">
              {props?.isRx || props?.isLogin   ? (
                <div>
                  <a>
                    <Image src={IC_CONTACT_EMAIL.src} width={60} height={60} alt="" />
                    <div className="ms-3">care@myaster.com</div>
                  </a>
                </div>
              ) : (
                <div>
                  <a>
                    <Image src={IC_CONTACT.src} width={60} height={60} alt="" />
                    <div
                      onClick={() => {
                        handleClick();
                      }}
                      className="ms-3 link"
                    >
                      Contact Us
                    </div>
                  </a>
                </div>
              )}
              <div className="innerText">
                {window.innerWidth <= MIN_MOBILE_WIDTH ? (
                  <>
                    {isTeleconsultRoute ? (
                      <a href={`tel: ${doctorHelpLine}`}>
                        <Image src={IC_CALL_BLUE.src} width={60} height={60} alt="" />
                        <div className="ms-3">{doctorHelpLine}</div>
                      </a>
                    ) : (
                      <a
                        href={
                          `tel:${props?.isRx || props?.isLogin  }`
                            ? '+971-800-700-600'
                            : appConfig?.find((x) => x.name === 'support_number')?.value
                        }
                      >
                        <Image src={IC_CALL_BLUE.src} width={60} height={60} alt="" />
                        <div className="ms-3 contactNum">
                        {
                          props?.isRx || props?.isLogin
                            ? '+971-800-700-600'
                            : (router?.pathname === '/home-care/appointments/detail/[appointmentId]' ||
                                router?.pathname === '/home-care/confirmation')
                              ? appConfig?.find((x) => x.name === 'homecare-support_number')?.value
                              : appConfig?.find((x) => x.name === 'support_number')?.value
                        }
                        </div>
                      </a>
                    )}
                  </>
                ) : (
                  <>
                    {isTeleconsultRoute ? (
                      <>
                        <Image src={IC_CALL_BLUE.src} width={60} height={60} alt="" />
                        <div className="ms-3">{doctorHelpLine}</div>
                      </>
                    ) : (
                      <>
                        <Image src={IC_CALL_BLUE.src} width={60} height={60} alt="" />
                        <div className="ms-3 contactNum">
                        {
                          props?.isRx || props?.isLogin
                            ? '+971-800-700-600'
                            : (router?.pathname === '/home-care/appointments/detail/[appointmentId]'||
                                router?.pathname === '/home-care/confirmation')
                              ? appConfig?.find((x) => x.name === 'homecare-support_number')?.value
                              : appConfig?.find((x) => x.name === 'support_number')?.value
                        }
                        </div>
                      </>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </HelpPopUpStyled>
  );
};

HelpPopUp.propTypes = {
  close: PropTypes.func,
  setShowContactSideBar: PropTypes.func,
  isRx: PropTypes.bool,
};

export default HelpPopUp;
